import { InjectionKey } from 'vue';
import { CheckoutSession } from '@/fairplayer/domain/CheckoutSession';
import { MembershipToCreate } from '@/fairplayer/domain/membership/MembershipToCreate';

export const membershipRepositoryKey: InjectionKey<MembershipRepository> = Symbol();

export interface MembershipRepository {
  create(membershipToCreate: MembershipToCreate): Promise<CheckoutSession>;
}
